import styled from 'styled-components'
import { Layout } from 'ui'

const { FlexItem } = Layout

export const StyledFlexItem = styled(FlexItem)`
  cursor: inherit;
`
